<article class="modal custom--modal modal--small" @fade>
  @if (config.header) {
    <header data-test-id="confirmationModalHeader" class="modal__header t-data">
      {{ config.header }}
    </header>
  }

  <section class="modal__body t-data">
    @if (config.HTMLBody) {
      <div [innerHtml]="config.HTMLBody"></div>
    } @else {
      {{ config.body | stringBuilder: context }}
    }
    <ng-template #body>
      {{ config.body | stringBuilder: context }}
    </ng-template>
  </section>

  <footer class="modal__footer">
    @if (config.confirm) {
      <p
        class="t-link t-data t-bold u-inline"
        data-test-id="confirmationModalConfirmButton"
        (click)="confirm.emit()"
      >
        {{ config.confirm }}
      </p>
    }
    @if (config?.cancel) {
      <p
        class="t-link t-data t-bold u-inline u-float-right"
        data-test-id="confirmationModalCancelButton"
        (click)="cancel.emit()"
        [innerHTML]="config.cancel"
      ></p>
    }
  </footer>
</article>
